import {FiX} from "react-icons/fi";
import {ClearIndicatorProps, components, GroupBase} from "react-select";

import {IconButton} from "@/components/iconButton/IconButton.tsx";

export const ClearIndicator = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: ClearIndicatorProps<Option, IsMulti, Group>
) => {
  return (
    <components.ClearIndicator {...props}>
      <IconButton
        className={"pulse-color-inherit"}
        icon={FiX}
        variant="ghost"
        size="fitIcon"
        onClick={props.clearValue}
      />
    </components.ClearIndicator>
  );
};
